import React from "react"
import moment from "moment"

import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

/**
 *
 * Renders a year cell, content is either undefined or an integer in order to perform min/max filtering
 */
export const YearCell = ({ rowId, columnId, children, sheetId, columnIndex, editing, ...props }) => {
    const formattingFn = (value) => (value ? Number(moment(value).local().format("YYYY")) : undefined)

    return (
        <CellWrapper {...props} formattingFn={formattingFn} isNumeric>
            {formattingFn(children)}
        </CellWrapper>
    )
}
